/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable max-len */
import React, { Component } from 'react';
import { convertPropToCssClassName } from '@elliemae/ds-classnames';
import { DSTooltip, TooltipType } from '@elliemae/ds-tooltip';
import { PopperInteractions as Interaction, PopperPositions as Position } from '@elliemae/ds-legacy-popper';
import { DSToggle } from '@elliemae/ds-legacy-form';
import { DSButton } from '@elliemae/ds-legacy-button-v1';
import { ParenthesisRemove, MoreOptionsVert, QueryAdd } from '@elliemae/ds-icons';
import { DSIconColors, DSIconSizes } from '@elliemae/ds-icon';
import { DELAY_CLOSE, DELAY_OPEN, TOOLBAR_ANIMATION_DURATION } from '../helpers/constants.js';
import { ToolBarAnimation } from '../ToolBarAnimation/ToolBarAnimation.js';
import DragContainerController from '../DragContainerController/DragContainerController.js';

const { cssClassName, classNameBlock, classNameElement, mainModifier, classNameBlockModifier } =
  convertPropToCssClassName('query-builder-and-or-controller');
/**
 * condition-display-step: required to avoid the cache of the trigger
 * @param e
 * @param isOpen
 */
class AndOrController extends Component {
  static defaultProps = {
    isMain: false,
    handleRuleContainerOperator: () => null,
    handleRuleContainerUnGroup: () => null,
    handleTooltipGroup: () => null,
    labelOn: 'AND',
    labelOff: 'OR',
    condition: true,
    showDragController: true,
    allowUnGroup: true,
    buttonActionSize: DSIconSizes.M,
    buttonActionType: 'text',
    toogleActionSize: DSIconSizes.S,
    onAddFilter: () => null,
    multipleSize: false,
    delayClose: DELAY_CLOSE,
    delayOpen: DELAY_OPEN,
    step: null,
    toolBarAnimationDuration: TOOLBAR_ANIMATION_DURATION,
    toolBarInteractionType: Interaction.CLICK,
    toolBarPosition: Position.LEFT,
  };

  constructor(props) {
    super(props);
    this.contenerRef = React.createRef();
    this.myRef = React.createRef();
    this.state = {
      isOpen: false,
      top: 0,
      right: -2,
    };
  }

  handleMouseEnterRow = (e) => {
    this.handleTooltipRow(true);
    // this.handleMouseMove(e)
  };

  handleMouseMove = (e) => {
    if (!this.contenerRef.current) return;
    const mouse = e.clientY;
    const { height } = this.contenerRef.current.getBoundingClientRect();
    const delta = height / 2;
    const topDiff = this.myRef.current.getBoundingClientRect().top;
    const refHeight = this.myRef.current.getBoundingClientRect().height;

    this.setState({
      top: mouse - topDiff - refHeight / 2 - delta,
    });
  };

  handleMouseLeaveRow = () => {
    this.handleTooltipRow(false);
  };

  handleTooltipRow = (isOpen) => {
    this.setState({ isOpen });
    const { handleTooltipGroup } = this.props;
    handleTooltipGroup(isOpen);
  };

  render() {
    const {
      handleRuleContainerOperator,
      handleRuleContainerUnGroup,
      labelOn,
      labelOff,
      condition,
      showDragController,
      allowUnGroup,
      buttonActionSize,
      buttonActionType,
      toogleActionSize,
      onAddFilter,
      multipleSize,
      delayClose,
      delayOpen,
      step,
      toolBarAnimationDuration,
      toolBarInteractionType,
      toolBarPosition,
      isMain,
      toolTipZIndex,
    } = this.props;
    const { isOpen, top, right } = this.state;
    return (
      <div
        ref={this.myRef}
        className={`${cssClassName} ${mainModifier(condition ? 'active' : 'default')} step-${step}  ${
          isMain ? 'is-main-group-join' : ''
        }`}
        // onMouseEnter={this.handleMouseEnterRow}
        onMouseLeave={this.handleMouseLeaveRow}
        // onMouseMove={this.handleMouseMove}
      >
        <div className={`${classNameBlock('content')} step-${step}`}>
          <DSTooltip
            delayClose={delayClose}
            delayOpen={delayOpen}
            interactionType={toolBarInteractionType}
            isOpen={isOpen}
            onOpen={this.handleTooltipRow}
            placement={toolBarPosition}
            springAnimationComponent={<ToolBarAnimation duration={toolBarAnimationDuration} />}
            step={step}
            title={
              <div
                ref={this.contenerRef}
                className={classNameBlock('actions')}
                style={{
                  transition: '0.2s',
                  position: 'absolute',
                  top: `${top}px`,
                  right: `${right}px`,
                }}
              >
                <DSTooltip
                  title="Add condition"
                  triggerComponent={
                    <DSButton
                      buttonType={buttonActionType}
                      className={classNameElement('add-rule')}
                      icon={<QueryAdd />}
                      onClick={onAddFilter}
                      size={buttonActionSize}
                      containerProps={{
                        'data-testid': 'query-add-button',
                      }}
                    />
                  }
                />
                {allowUnGroup && (
                  <DSTooltip
                    title="Remove group"
                    triggerComponent={
                      <DSButton
                        buttonType="text"
                        className={classNameElement('ungroup')}
                        icon={<ParenthesisRemove />}
                        onClick={handleRuleContainerUnGroup}
                        size={buttonActionSize}
                        containerProps={{
                          'data-testid': 'parenthesis-remove-button',
                        }}
                      />
                    }
                  />
                )}
                <DSToggle
                  checked={condition}
                  className={classNameElement('and-or-toggle')}
                  labelOff={labelOff}
                  labelOn={labelOn}
                  onChange={(e) => handleRuleContainerOperator(e.target.checked)}
                  size={toogleActionSize}
                  containerProps={{
                    'data-testid': 'and-or-toggle-button',
                  }}
                />
              </div>
            }
            tooltipType={TooltipType.TOOLBAR}
            triggerComponent={
              <div
                className={`${classNameBlock('trigger-controller')} ${
                  showDragController ? classNameBlockModifier('draggable', 'trigger-controller') : ''
                } step-${step}`}
              >
                <div className={classNameElement('condition-display')}>
                  <span className={classNameElement('condition-display-label')}>{condition ? labelOn : labelOff}</span>
                  <span className={classNameElement('condition-display-step')}>{step}</span>
                  <div className="separator" />
                  <MoreOptionsVert
                    color={DSIconColors.NEUTRAL}
                    onClick={this.handleMouseEnterRow}
                    size={DSIconSizes.S}
                    containerProps={{
                      'data-testid': 'and-or-more-options-button',
                    }}
                  />
                </div>
                {showDragController && (
                  <DragContainerController multipleSize={multipleSize} onClick={this.handleMouseEnterRow} />
                )}
              </div>
            }
            zIndex={toolTipZIndex}
          />
        </div>
      </div>
    );
  }
}

export default AndOrController;
